import {Component, effect, inject, input, ResourceStatus, ViewChild} from '@angular/core';
import {LeadResources} from '../../../resources/lead.resources';
import {SessionResources} from '../../../resources/session.resources';
import {ActivatedRoute, Router, RouterOutlet} from '@angular/router';
import {FIREBASE_AUTH} from '../../config/module.di.tokens';
import {SubNavbarComponent} from '../subscription-completion/sub-navbar/sub-navbar.component';
import {Lead} from '../../../data/domain/lead';
import {SubscriptionContextV2Service} from '../../../services/subscription-v2-context.service';
import {SubV2HeaderComponent} from './sub-v2-header/sub-v2-header.component';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-subscription-v2',
  imports: [
    SubV2HeaderComponent,
    RouterOutlet,
    NgIf
  ],
  templateUrl: './subscription-v2.component.html',
})
export class SubscriptionV2Component {

  sessionId = input<string>()
  sessionResources = inject(SessionResources)
  leadResources = inject(LeadResources)
  router = inject(Router)
  route = inject(ActivatedRoute)
  auth = inject(FIREBASE_AUTH)
  subscriptionContextV2Service = inject(SubscriptionContextV2Service)

  @ViewChild(SubNavbarComponent)
  navbar: SubNavbarComponent;

  constructor() {

    effect(() => this.sessionResources.sessionIdRequest.set(this.sessionId()));
    effect(() => {
      const leadStatus = this.leadResources.currentLead.status()
      if(leadStatus == ResourceStatus.Resolved) {
        const leadDTO = this.leadResources.currentLead.value()
        if(leadDTO) {
          this.updateSexAtChange(leadDTO)
          this.updateCurrentUserAtChange(leadDTO)
          if(leadDTO.offer) {
            this.subscriptionContextV2Service.defaultOffer.set(leadDTO.offer)
          }
        }
      }
    });
    effect(async () => {
      const sessionStatus = this.sessionResources.session.status()
      if(sessionStatus == ResourceStatus.Resolved) {
        const session = this.sessionResources.session.value()
        if(session && this.leadResources.currentLead.value() == null) {
          this.leadResources.retrieveLeadRequest.set({
            sessionId: session.id,
            phone: this.auth.currentUser?.phoneNumber
          })
        }
      }
    });
  }


  private updateSexAtChange(leadDTO: Lead) {
    if (leadDTO?.sex && !this.subscriptionContextV2Service.sex()) {
      this.subscriptionContextV2Service.sex.set(this.leadResources.currentLead.value()?.sex)
    }
  }

  private updateCurrentUserAtChange(leadDTO: Lead)  {
    if (leadDTO?.phone && this.auth.currentUser && this.auth.currentUser.phoneNumber != leadDTO.phone) {
      leadDTO.subscription = null
      leadDTO.phone = this.auth.currentUser.phoneNumber
      this.leadResources.saveLeadRequest.set(leadDTO)
    }
  }
}
